import { compose, lifecycle, nest, setDisplayName } from 'recompose'
import { connect } from 'react-redux'
import AppProvider from 'src/providers'
import { errorBoundary } from 'src/composables'
import { fetchCurrentUser } from 'src/actions/currentUser'

const AppContainer = Component =>
  setDisplayName('App')(
    nest(
      AppProvider,
      compose(
        errorBoundary(),
        connect(
          null,
          dispatch => ({
            loadUser: () => dispatch(fetchCurrentUser())
          })
        ),
        lifecycle({
          componentDidMount () {
            this.props.loadUser()
          }
        })
      )(Component)
    )
  )

export default AppContainer
